import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { ISidebarFooterProps } from '@cbridge-modules/sidebar';
import { SettingsItem } from './SettingsItem';

export const ConfigSidebarFooter: FC<ISidebarFooterProps> = (props) => {
  const { mini, toggleAction } = props;

  const { t } = useTranslation();

  return (
    <Stack
      component={'ul'}
      sx={{
        m: 0,
        p: 0,
      }}>
      <Divider />
      {mini ? (
        <Tooltip title={t('text:navigation.config.settings.title')} placement={'right'}>
          <SettingsItem mini={mini} toggleAction={toggleAction} />
        </Tooltip>
      ) : (
        <SettingsItem mini={mini} toggleAction={toggleAction} />
      )}
      {mini && (
        <ListItem
          sx={{
            justifyContent: 'center',
            overflowX: 'hidden',
          }}
        >
          {toggleAction}
        </ListItem>
      )}
    </Stack>
  );
};
